import { render } from "./AccountView.vue?vue&type=template&id=168a15b8&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=168a15b8&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168a15b8"]])

export default __exports__